var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetPriorityRed3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 78.619 80.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flaga1-11",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_521",
    "data-name": "Ellipse 521",
    cx: 38.31,
    cy: 39.019,
    rx: 38.31,
    ry: 39.019,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e00056",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(24.371 20.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 9.026,
    height: 9.026,
    fill: "#e00056"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 9.026,
    height: 9.026,
    transform: "translate(19.256)",
    fill: "#e00056"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M45.4,90.965a15.5,15.5,0,0,1,30.99,0",
    transform: "translate(-22.293 -31.892)",
    fill: "none",
    stroke: "#e00056",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetPriorityRed3);
export default __webpack_public_path__ + "static/media/set-priority-red3.536945f08600dbb54b1a52f64657d8c9.svg";
export { ForwardRef as ReactComponent };